<script setup lang="ts">
import { ChevronUp } from 'lucide-vue-next';
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';

const triggerVariants = cva('', {
  variants: {
    variant: {
      default: 'border-gray-500 bg-gray-50 text-text-primary-700',
      active: 'border-brand-primary-700 bg-brand-primary-50 text-brand-primary-700',
      disabled: 'border-gray-400 bg-gray-50 text-gray-500',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const chevronVariants = cva('', {
  variants: {
    variant: {
      default: 'text-text-primary-700',
      active: 'text-brand-primary-700',
      disabled: 'text-gray-400',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

type FilterTriggerVariant = VariantProps<typeof triggerVariants>['variant'];

interface FilterTriggerProperties {
  variant?: FilterTriggerVariant;
  isOpened?: boolean;
}

withDefaults(defineProps<FilterTriggerProperties>(), {
  variant: 'default',
  isOpened: false,
});
</script>

<template>
  <button
    class="relative flex h-10 w-fit items-center gap-2 rounded-lg border px-3.5 py-2.5 transition before:pointer-events-none before:absolute before:inset-border-outset before:rounded-lg before:border-2 before:transition before:content-empty md:w-full md:min-w-0"
    :class="[
      triggerVariants({ variant: variant }),
      isOpened ? 'before:border-brand-primary-500' : 'before:border-transparent',
    ]"
    :disabled="variant === 'disabled'"
    type="button"
  >
    <span class="truncate text-left text-sm font-normal md:min-w-0 md:flex-1"><slot /></span>
    <ChevronUp
      class="h-5 w-5 shrink-0 transition duration-300"
      :class="[isOpened ? '' : 'rotate-180', chevronVariants({ variant })]"
      aria-hidden="true"
    />
  </button>
</template>
